import axios from "axios";

export const Departamentos = [
    {nombre: "Seleccionar", codigo: -1},
    {nombre: "Amazonas", codigo: 91},
    {nombre: "Antioquia", codigo:5},
    {nombre: "Arauca", codigo:81},		
    {nombre: "Atlántico", codigo:8},
    {nombre: "Bogotá D.C.", codigo:11},
    {nombre: "Bolivar", codigo:13},
    {nombre: "Boyacá", codigo:15},
    {nombre: "Caldas",	 codigo:17},
    {nombre: "Caquetá", codigo:18},
    {nombre: "Casanare", codigo:85},
    {nombre: "Cauca",	 codigo:19},
    {nombre: "Cesar",	 codigo:20},
    {nombre: "Chocó",	 codigo:27},
    {nombre: "Córdoba",	 codigo:23},
    {nombre: "Cundinamarca", codigo:25},
    {nombre: "Guainía", codigo:94},
    {nombre: "Guaviare", codigo:95},
    {nombre: "Huila", codigo:41},
    {nombre: "La Guajira", codigo:44},
    {nombre: "Magdalena", codigo:47},
    {nombre: "Meta", codigo:50},
    {nombre: "Nariño", codigo:52},
    {nombre: "Norte de Santander", codigo:54},
    {nombre: "Putumayo", codigo:86},
    {nombre: "Quindío",	codigo:63},
    {nombre: "Risaralda", codigo:66},
    {nombre: "San Andrés y Providencia", codigo:88},
    {nombre: "Santander", codigo:68},
    {nombre: "Sucre", codigo:70},
    {nombre: "Tolima", codigo:73},
    {nombre: "Valle del Cauca", codigo:76},
    {nombre: "Vaupés", codigo:97},
    {nombre: "Vichada", codigo:99}
];

export const traerMunicipios = async (urlBaseRest, idDepto, setMunicipios) => {
    if (idDepto == null)  {
        return;
    }

    const _traerMunicipios = async(url) => {
        if (!url) {
            return;
        }
        const res = await axios(url);
        let mns =[
            {nombre: "Seleccionar", codigo: -1},
        ]
        for (var i = 0; i < res.data.length; i++) {
            mns.push({
                codigo: res.data[i].CODIGO_DPT,
                nombre: res.data[i].NOMBRE_MUN
            });
        }
        return mns;
    };
    
    let mns = await _traerMunicipios(urlBaseRest+"municipios/"+idDepto);
    setMunicipios(mns);
    return mns;
}

export const traerCPs = async (urlBaseRest, idMun, setCentrosPoblados) => {
    if (idMun == null) {
        return;
    }

    const _traerCPs = async(url) => {	            
        if (!url) {
            return null;
        }
        const res = await axios(url);
        console.log("res");
        console.log(res);
        let cps =[{nombre: "Seleccionar", codigo: -1, tipo:""}]

        for (var i = 0; i < res.data.length; i++) {
            cps.push({
                codigo: res.data[i].COD_CENTRO_POBLADO,
                nombre: res.data[i].SGEO_NOMBR,
                tipo: res.data[i].TIPO_CENTRO_POBLADO
            });
        }       

        return cps;
    };
    
    let cps = await _traerCPs(urlBaseRest+"centros_poblados/"+idMun);
    setCentrosPoblados(cps);

    return cps;
}

export const buscarCPConMismoNombre = (nombreMun, cps)=> {
    if (nombreMun== null || cps == null || cps.length == 0) {
        return null;
    }

    let nm = nombreMun.toLowerCase().trim();
    for (let i = 0; i < cps.length; i++) {
        let cp = cps[i];
        if (cp.nombre.toLowerCase().trim() === nm ) {
            return cp;            
        }
    }
    
    return cps[0];
}

export const buscarCabeceraMunicipal = (cps)=> {   
    console.log(cps) 
    for (let i = 0; i < cps.length; i++) {
        let cp = cps[i];
        if (cp.tipo.toUpperCase().trim() === "CABECERA MUNICIPAL" ) {
            return cp;            
        }
    }
    
    return cps[0];
}